module.exports = __webpack_public_path__ + "static/media/logo-footer.438bf2c9.png";